// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"53":"5c174234","288":"73b7b3ac","392":"3de4fa2a","929":"46339908"}[chunkId] + ".css";
};